import { PreferenceScope, UserPreferenceKey } from '../types';
import { useUserPreferences } from './useUserPreferences';

/**
 * True when the user has opted into a themed (light/dark) appearance — i.e. the
 * global ColorMode preference is anything other than 'legacy'. Single source of
 * truth for the `data-theme` opt-in check used by themed feature surfaces.
 */
export const useIsThemedAppearance = (): boolean => {
  const { preferences } = useUserPreferences(PreferenceScope.GLOBAL);
  return (preferences[UserPreferenceKey.ColorMode] ?? 'legacy') !== 'legacy';
};
